import { useUser } from '~/app/contexts/UserContext';
import { RouteObject } from '~/app/types';
import { MixPanel } from '~/shared/lib/mixpanel';

export function useNavAnalytics() {
  const user = useUser();

  const fireMenuItemClick = (item: RouteObject) => {
    MixPanel.fireEvent({
      event: 'Nav_menu_click',
      properties: { menuItem: item.key },
      session: { user },
    });
  };

  return { fireMenuItemClick };
}
